import { TFunction } from "react-i18next";

import { Shipment } from "../../../../models/shipments";
import { ValueOf } from "../../../../types";
import { ShipmentDetails } from "../../../../util/enums";

export const getExtendedFormInputInfoByType = (
  type: string,
  translate: TFunction<"translation", undefined>
) => {
  switch (type?.toLowerCase()) {
    case "air":
      return {
        origin: {
          label: translate("shipperOriginAirport"),
          placeholder: translate("airportName"),
          dataCy: "shipperOriginAirport",
        },
        discharge: {
          label: translate("shipperDischargeAirport"),
          placeholder: translate("portName"),
          dataCy: "shipperDischargeAirport",
        },
        receipt: {
          label: translate("shipperReceiptAirport"),
          placeholder: translate("portName"),
          dataCy: "shipperReceiptAirport",
        },
        destination: {
          label: translate("receiverDestinationAirport"),
          placeholder: translate("airportName"),
          dataCy: "receiverDestinationAirport",
        },
      };
    case "sea":
      return {
        origin: {
          label: `${translate("portOfLoading")} (PoL)`,
          placeholder: translate("portName"),
          dataCy: "portOfLoading",
        },
        discharge: {
          label: `${translate("portOfDischarge")} (PoD)`,
          placeholder: translate("portName"),
          dataCy: "portOfDischarge",
        },
        receipt: {
          label: translate("placeOfReceipt"),
          placeholder: translate("portName"),
          dataCy: "placeOfReceipt",
        },
        destination: {
          label: translate("placeOfDestination"),
          placeholder: translate("portName"),
          dataCy: "placeOfDestination",
        },
      };
    case "road":
      return {
        origin: {
          label: translate("senderOriginRoad"),
          placeholder: translate("roadName"),
        },
        destination: {
          label: translate("receiverDestinationRoad"),
          placeholder: translate("roadName"),
        },
      };
    default:
      return null;
  }
};

export type ShipmentKey = keyof Shipment | "all";

export interface DetailsSectionsProps {
  fieldHasError: (field: string) => boolean;
  getErrorByField: (field: string) => string | undefined;
  onUpdateShipmentDetails: (
    key: ShipmentKey,
    value: ValueOf<Shipment> | null,
    noChanges?: boolean
  ) => void;
  viewOnly?: boolean;
  data?: Shipment;
  generateBaseFieldProps: (name: ShipmentDetails) => BaseFieldProps;
}

export interface BaseFieldProps {
  error: boolean;
  errorMessage: string | undefined;
  "data-cy": ShipmentDetails;
  dataCy: ShipmentDetails;
  label: string;
  placeholder: string;
  "aria-label": ShipmentDetails;
  disabled: boolean | undefined;
  name: ShipmentDetails;
}
